const path = {
  "Dashboard": "/dashboard",
  "OverView": "/iisp/overview",
  "NewYul":"/iisp/new_vul",
  "Asset":"/iisp/asset",
  "SecPrac":"/iisp/sec_prac",
  "BugSearch":"/iisp/bug_search",
  // 域名安全监控新增API
  "DomainSecurity": "/api",
  // 递归侧 PassiveDNS API
  "PassiveDNS": "/passivedns",
  // MongoDB劫持案例API
  "PassiveDNSMongo": "/passivedns-mongo",
  // 授权依赖 MongoDB API
  "AuthDepMongo": "/authdep-api",
  // 恶意域名检测API（后端 202.112.47.187:13691 /api/malicious/*，API Key 由服务端代理注入）
  "Malicious": "/malicious-api",
  // DNS解析器演化追踪API（后端 202.112.51.102:7788 /api/dns_resolver_dashboard/*.json）
  "ResolverDash": "/resolver-api",
  // 黑帽SEO通报API（本地离线索引数据源，路径由 ABUSE_INDEX_DIR 指定）
  "AbuseSeo": "/abuse-api"
};

export {path};
